import React from "react";
import { safeLocalFormat } from "../../../../utilities/functions";

const PunchInRender = ({ row }) => {
  return (
    <>
      {row.attendances.map((Punchin, index) => (
        <p style={{ borderBottom: "1px solid #F7F9FB" }}>
          {Punchin.punchIn ? safeLocalFormat(Punchin.punchIn) : ""}
        </p>
      ))}
    </>
  );
};

export default PunchInRender;
